module.exports = __webpack_public_path__ + "img/7.c292cef4.png";